import { ChevronRight } from 'lucide-react';
import type { FeatureMeta } from './features-catalog';
import styles from './ToolCard.module.css';

type Props = {
  meta: FeatureMeta;
  onClick: () => void;
  /**
   * Optional tint override. The drawer now groups activities by scope
   * (module/section/course) and unifies the colour per group so the
   * three blocks read as one coherent surface each, instead of the
   * per-activity rainbow that came from the original feature taxonomy.
   */
  tint?: string;
};

export function ToolCard({ meta, onClick, tint }: Props) {
  const Icon = meta.icon;
  return (
    <button
      type="button"
      className={styles.card}
      onClick={onClick}
      style={{ ['--tint' as string]: tint ?? meta.tint }}
      aria-label={meta.label}
    >
      <div className={styles.tint} aria-hidden />
      <div className={styles.content}>
        <div className={styles.iconRow}>
          <Icon size={20} strokeWidth={1.8} className={styles.icon} />
          {meta.beta && <span className={styles.beta}>BETA</span>}
        </div>
        <span className={styles.label}>{meta.label}</span>
      </div>
      <span className={styles.chev} aria-hidden>
        <ChevronRight size={16} strokeWidth={2} />
      </span>
    </button>
  );
}
